// extracted by mini-css-extract-plugin
module.exports = {"container":"CartSuccess_container__1mmaL","icon":"CartSuccess_icon__1Y69n"};